// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BankDetailsView_modalOverlay__DzMP\\+ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  animation: BankDetailsView_fadeIn__-hlTV 0.3s ease;
}

.BankDetailsView_modal__tLJGa {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: BankDetailsView_slideUp__m9Q31 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.BankDetailsView_modalHeader__PqFua {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 35px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.BankDetailsView_modalHeader__PqFua h2 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}
.BankDetailsView_modalHeader__PqFua .BankDetailsView_closeButton__szzLw {
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 1.8rem;
  cursor: pointer;
  padding: 0;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}
.BankDetailsView_modalHeader__PqFua .BankDetailsView_closeButton__szzLw:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.BankDetailsView_form__PN6rt {
  padding: 35px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.BankDetailsView_tableContainer__rIwyL {
  margin-bottom: 25px;
  border: 2px solid #e3e6f0;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  background: white;
}

.BankDetailsView_formTable__SoAnA {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.05rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.BankDetailsView_formTable__SoAnA th, .BankDetailsView_formTable__SoAnA td {
  border: 1px solid #e3e6f0;
  padding: 18px 20px;
  text-align: left;
  vertical-align: top;
  position: relative;
}
.BankDetailsView_formTable__SoAnA th {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 700;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  font-size: 1.1rem;
  letter-spacing: 0.3px;
}
.BankDetailsView_formTable__SoAnA .BankDetailsView_centerHeader__nKTW5 {
  text-align: center;
  font-size: 1.3rem;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
  padding: 25px 20px;
}
.BankDetailsView_formTable__SoAnA td:first-child {
  font-weight: 700;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  width: 220px;
  color: #495057;
  font-size: 1rem;
  border-right: 2px solid #dee2e6;
}
.BankDetailsView_formTable__SoAnA .BankDetailsView_displayValue__1-x7m {
  padding: 12px 16px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid #e9ecef;
  border-radius: 8px;
  min-height: 24px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.BankDetailsView_formTable__SoAnA .BankDetailsView_displayValue__1-x7m:hover {
  border-color: #667eea;
  box-shadow: inset 0 2px 4px rgba(102, 126, 234, 0.1);
}
.BankDetailsView_formTable__SoAnA tr:nth-child(even) {
  background: rgba(248, 249, 250, 0.5);
}
.BankDetailsView_formTable__SoAnA tr:hover {
  background: rgba(102, 126, 234, 0.02);
}

.BankDetailsView_note__pw431 {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  border: 2px solid #ffc107;
  border-radius: 12px;
  padding: 20px 25px;
  margin: 25px 0;
  color: #856404;
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.2);
  position: relative;
  overflow: hidden;
}
.BankDetailsView_note__pw431::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffc107, #ff8f00);
}
.BankDetailsView_note__pw431 p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
}

.BankDetailsView_formActions__EleuX {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 35px;
  padding-top: 25px;
  border-top: 2px solid rgba(102, 126, 234, 0.1);
}
.BankDetailsView_formActions__EleuX .BankDetailsView_closeButton__szzLw {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
  border: none;
  padding: 15px 35px;
  border-radius: 30px;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}
.BankDetailsView_formActions__EleuX .BankDetailsView_closeButton__szzLw::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}
.BankDetailsView_formActions__EleuX .BankDetailsView_closeButton__szzLw:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(108, 117, 125, 0.4);
}
.BankDetailsView_formActions__EleuX .BankDetailsView_closeButton__szzLw:hover::before {
  left: 100%;
}
.BankDetailsView_formActions__EleuX .BankDetailsView_closeButton__szzLw:active {
  transform: translateY(-1px);
}

@keyframes BankDetailsView_fadeIn__-hlTV {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes BankDetailsView_slideUp__m9Q31 {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 768px) {
  .BankDetailsView_modalOverlay__DzMP\\+ {
    padding: 10px;
  }
  .BankDetailsView_modal__tLJGa {
    max-height: 95vh;
  }
  .BankDetailsView_modalHeader__PqFua {
    padding: 25px 20px;
  }
  .BankDetailsView_modalHeader__PqFua h2 {
    font-size: 1.6rem;
  }
  .BankDetailsView_form__PN6rt {
    padding: 25px;
  }
  .BankDetailsView_formTable__SoAnA {
    font-size: 0.95rem;
  }
  .BankDetailsView_formTable__SoAnA th, .BankDetailsView_formTable__SoAnA td {
    padding: 15px 12px;
  }
  .BankDetailsView_formTable__SoAnA .BankDetailsView_centerHeader__nKTW5 {
    font-size: 1.1rem;
    padding: 20px 15px;
  }
  .BankDetailsView_formTable__SoAnA td:first-child {
    width: 180px;
    font-size: 0.9rem;
  }
  .BankDetailsView_formTable__SoAnA .BankDetailsView_displayValue__1-x7m {
    padding: 10px 12px;
    font-size: 0.9rem;
  }
  .BankDetailsView_note__pw431 {
    padding: 15px 20px;
  }
  .BankDetailsView_note__pw431 p {
    font-size: 0.9rem;
  }
  .BankDetailsView_formActions__EleuX {
    flex-direction: column;
    align-items: center;
  }
  .BankDetailsView_formActions__EleuX .BankDetailsView_closeButton__szzLw {
    width: 100%;
    max-width: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/bank-details/BankDetailsView.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,kDAAA;AACF;;AAEA;EACE,6DAAA;EACA,mBAAA;EACA,8EAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mDAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,6DAAA;EACA,YAAA;EACA,4BAAA;EACA,+CAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,qBAAA;AACJ;AAEE;EACE,qCAAA;EACA,0CAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;AAAJ;AAEI;EACE,qCAAA;EACA,qBAAA;EACA,yCAAA;AAAN;;AAKA;EACE,aAAA;EACA,6DAAA;AAFF;;AAKA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,iBAAA;AAFF;;AAKA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4DAAA;AAFF;AAIE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,6DAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,iBAAA;EACA,qBAAA;AAHJ;AAME;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6DAAA;EACA,YAAA;EACA,yCAAA;EACA,qBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,gBAAA;EACA,6DAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;AALJ;AAQE;EACE,kBAAA;EACA,6DAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,+CAAA;EACA,yBAAA;AANJ;AAQI;EACE,qBAAA;EACA,oDAAA;AANN;AAWE;EACE,oCAAA;AATJ;AAYE;EACE,qCAAA;AAVJ;;AAcA;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;AAXF;AAaE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;AAXJ;AAcE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,+CAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,8CAAA;AAbF;AAeE;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,+CAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAbJ;AAeI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,qBAAA;AAbN;AAgBI;EACE,2BAAA;EACA,gDAAA;AAdN;AAgBM;EACE,UAAA;AAdR;AAkBI;EACE,2BAAA;AAhBN;;AAsBA;EACE;IACE,UAAA;EAnBF;EAqBA;IACE,UAAA;EAnBF;AACF;AAsBA;EACE;IACE,UAAA;IACA,uCAAA;EApBF;EAsBA;IACE,UAAA;IACA,iCAAA;EApBF;AACF;AAwBA;EACE;IACE,aAAA;EAtBF;EAyBA;IACE,gBAAA;EAvBF;EA0BA;IACE,kBAAA;EAxBF;EA0BE;IACE,iBAAA;EAxBJ;EA4BA;IACE,aAAA;EA1BF;EA6BA;IACE,kBAAA;EA3BF;EA6BE;IACE,kBAAA;EA3BJ;EA8BE;IACE,iBAAA;IACA,kBAAA;EA5BJ;EA+BE;IACE,YAAA;IACA,iBAAA;EA7BJ;EAgCE;IACE,kBAAA;IACA,iBAAA;EA9BJ;EAkCA;IACE,kBAAA;EAhCF;EAkCE;IACE,iBAAA;EAhCJ;EAoCA;IACE,sBAAA;IACA,mBAAA;EAlCF;EAoCE;IACE,WAAA;IACA,gBAAA;EAlCJ;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(8px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n  animation: fadeIn 0.3s ease;\n}\n\n.modal {\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n  border-radius: 20px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);\n  max-width: 1000px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  animation: slideUp 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 35px;\n  border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 20px 20px 0 0;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n\n  h2 {\n    margin: 0;\n    font-size: 2rem;\n    font-weight: 700;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    letter-spacing: 0.5px;\n  }\n\n  .closeButton {\n    background: rgba(255, 255, 255, 0.15);\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    color: white;\n    font-size: 1.8rem;\n    cursor: pointer;\n    padding: 0;\n    width: 45px;\n    height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.25);\n      transform: scale(1.1);\n      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n\n.form {\n  padding: 35px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n}\n\n.tableContainer {\n  margin-bottom: 25px;\n  border: 2px solid #e3e6f0;\n  border-radius: 15px;\n  overflow: hidden;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n  background: white;\n}\n\n.formTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.05rem;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n\n  th, td {\n    border: 1px solid #e3e6f0;\n    padding: 18px 20px;\n    text-align: left;\n    vertical-align: top;\n    position: relative;\n  }\n\n  th {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    font-weight: 700;\n    text-align: center;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n    font-size: 1.1rem;\n    letter-spacing: 0.3px;\n  }\n\n  .centerHeader {\n    text-align: center;\n    font-size: 1.3rem;\n    font-weight: 800;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n    letter-spacing: 0.5px;\n    padding: 25px 20px;\n  }\n\n  td:first-child {\n    font-weight: 700;\n    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n    width: 220px;\n    color: #495057;\n    font-size: 1rem;\n    border-right: 2px solid #dee2e6;\n  }\n\n  .displayValue {\n    padding: 12px 16px;\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border: 2px solid #e9ecef;\n    border-radius: 8px;\n    min-height: 24px;\n    font-weight: 600;\n    color: #2c3e50;\n    font-size: 1rem;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: all 0.3s ease;\n\n    &:hover {\n      border-color: #667eea;\n      box-shadow: inset 0 2px 4px rgba(102, 126, 234, 0.1);\n    }\n  }\n\n  // Style for table data rows\n  tr:nth-child(even) {\n    background: rgba(248, 249, 250, 0.5);\n  }\n\n  tr:hover {\n    background: rgba(102, 126, 234, 0.02);\n  }\n}\n\n.note {\n  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n  border: 2px solid #ffc107;\n  border-radius: 12px;\n  padding: 20px 25px;\n  margin: 25px 0;\n  color: #856404;\n  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.2);\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(90deg, #ffc107, #ff8f00);\n  }\n\n  p {\n    margin: 0;\n    font-size: 1rem;\n    line-height: 1.6;\n    font-weight: 600;\n    text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);\n  }\n}\n\n.formActions {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 35px;\n  padding-top: 25px;\n  border-top: 2px solid rgba(102, 126, 234, 0.1);\n\n  .closeButton {\n    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n    color: white;\n    border: none;\n    padding: 15px 35px;\n    border-radius: 30px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 6px 20px rgba(108, 117, 125, 0.3);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    position: relative;\n    overflow: hidden;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -100%;\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n      transition: left 0.5s;\n    }\n\n    &:hover {\n      transform: translateY(-3px);\n      box-shadow: 0 10px 25px rgba(108, 117, 125, 0.4);\n      \n      &::before {\n        left: 100%;\n      }\n    }\n\n    &:active {\n      transform: translateY(-1px);\n    }\n  }\n}\n\n// Animations\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .modalOverlay {\n    padding: 10px;\n  }\n\n  .modal {\n    max-height: 95vh;\n  }\n\n  .modalHeader {\n    padding: 25px 20px;\n\n    h2 {\n      font-size: 1.6rem;\n    }\n  }\n\n  .form {\n    padding: 25px;\n  }\n\n  .formTable {\n    font-size: 0.95rem;\n\n    th, td {\n      padding: 15px 12px;\n    }\n\n    .centerHeader {\n      font-size: 1.1rem;\n      padding: 20px 15px;\n    }\n\n    td:first-child {\n      width: 180px;\n      font-size: 0.9rem;\n    }\n\n    .displayValue {\n      padding: 10px 12px;\n      font-size: 0.9rem;\n    }\n  }\n\n  .note {\n    padding: 15px 20px;\n    \n    p {\n      font-size: 0.9rem;\n    }\n  }\n\n  .formActions {\n    flex-direction: column;\n    align-items: center;\n    \n    .closeButton {\n      width: 100%;\n      max-width: 300px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `BankDetailsView_modalOverlay__DzMP+`,
	"fadeIn": `BankDetailsView_fadeIn__-hlTV`,
	"modal": `BankDetailsView_modal__tLJGa`,
	"slideUp": `BankDetailsView_slideUp__m9Q31`,
	"modalHeader": `BankDetailsView_modalHeader__PqFua`,
	"closeButton": `BankDetailsView_closeButton__szzLw`,
	"form": `BankDetailsView_form__PN6rt`,
	"tableContainer": `BankDetailsView_tableContainer__rIwyL`,
	"formTable": `BankDetailsView_formTable__SoAnA`,
	"centerHeader": `BankDetailsView_centerHeader__nKTW5`,
	"displayValue": `BankDetailsView_displayValue__1-x7m`,
	"note": `BankDetailsView_note__pw431`,
	"formActions": `BankDetailsView_formActions__EleuX`
};
export default ___CSS_LOADER_EXPORT___;
